module.exports = __webpack_public_path__ + "img/living-room-7939062_1280_thumb.df3f3d17.png";